import React, { FC } from "react";
import { AdminCampaignsView } from "../../components";

export const AdminCampaignsPage: FC = () => {
  return <AdminCampaignsView />;
};
